import { Component, Directive, booleanAttribute, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import {
  CdkRow,
  CdkRowDef,
  CdkFooterRow,
  CdkHeaderRow,
  CdkNoDataRow,
  CdkCellOutlet,
  CdkFooterRowDef,
  CdkHeaderRowDef,
} from '@angular/cdk/table';

const ROW_TEMPLATE = `<ng-container cdkCellOutlet></ng-container>`;

@Directive({
  selector: '[appTableHeaderRowDef]',
  providers: [{ provide: CdkHeaderRowDef, useExisting: TableHeaderRowDef }],
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [
    { name: 'columns', alias: 'appTableHeaderRowDef' },
    { name: 'sticky', alias: 'appTableHeaderRowDefSticky', transform: booleanAttribute },
  ],
})
export class TableHeaderRowDef extends CdkHeaderRowDef {}

@Directive({
  selector: '[appTableFooterRowDef]',
  providers: [{ provide: CdkFooterRowDef, useExisting: TableFooterRowDef }],
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [
    { name: 'columns', alias: 'appTableFooterRowDef' },
    { name: 'sticky', alias: 'appTableFooterRowDefSticky', transform: booleanAttribute },
  ],
})
export class TableFooterRowDef extends CdkFooterRowDef {}

@Directive({
  selector: '[appTableRowDef]',
  providers: [{ provide: CdkRowDef, useExisting: TableRowDef }],
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [
    { name: 'columns', alias: 'appTableRowDefColumns' },
    { name: 'when', alias: 'appTableRowDefWhen' },
  ],
})
export class TableRowDef<T> extends CdkRowDef<T> {}

@Component({
  selector: 'app-table-header-row, tr[appTableHeaderRow]',
  exportAs: 'appTableHeaderRow',
  providers: [{ provide: CdkHeaderRow, useExisting: TableHeaderRow }],
  imports: [CdkCellOutlet],
  template: ROW_TEMPLATE,
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'app-table-header-row',
    role: 'row',
  },
})
export class TableHeaderRow extends CdkHeaderRow {}

@Component({
  selector: 'app-table-footer-row, tr[appTableFooterRow]',
  exportAs: 'appTableFooterRow',
  providers: [{ provide: CdkFooterRow, useExisting: TableFooterRow }],
  imports: [CdkCellOutlet],
  template: ROW_TEMPLATE,
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'app-table-footer-row',
    role: 'row',
  },
})
export class TableFooterRow extends CdkFooterRow {}

@Component({
  selector: 'app-table-row, tr[appTableRow]',
  exportAs: 'appTableRow',
  providers: [{ provide: CdkRow, useExisting: TableRow }],
  imports: [CdkCellOutlet],
  template: ROW_TEMPLATE,
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'app-table-row',
    role: 'row',
  },
})
export class TableRow extends CdkRow {}

@Directive({
  selector: 'ng-template[appTableNoDataRow]',
  providers: [{ provide: CdkNoDataRow, useExisting: TableNoDataRow }],
})
export class TableNoDataRow extends CdkNoDataRow {
  override _cellSelector = 'td, app-table-cell, [appTableCell], .app-table-cell';

  constructor() {
    super();
    this._contentClassNames.push('app-table-no-data-row', 'app-table-row');
    this._cellClassNames.push('app-table-no-data-cell', 'app-table-cell');
  }
}
